<script setup>
import {onMounted, reactive, computed, nextTick, ref} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {Permissions} from "@/Utils/Permissions";
import {FormValidation} from "@/Utils/FormValidation";
import {ToastUtil} from "@/Utils/ToastUtil";

const compName = 'ClientListComponent';

const data = reactive({
  Clients: [],
  dataLoading: true,
  editedItem: {
    name: '',
    city: null,
    state: null,
    zip: null,
    streetaddress: null,
    phone: '',
  },
  defaultItem: {
    name: '',
    city: null,
    state: null,
    zip: null,
    streetaddress: null,
    phone: '',
  },
  headers: [
    {
      title: 'Name',
      align: 'start',
      sortable: true,
      key: 'name',
    },
    { title: 'Address', key: 'clientAddress', sortable: false },
    { title: 'Phone', key: 'phone', sortable: false },
    { title: 'Actions', key: 'actions', sortable: false },
    { title: 'clientreps', key: 'clientrepnames', align: ' d-none' },
    { title: 'homephones', key: 'homephones', align: ' d-none' },
    { title: 'workphones', key: 'workphones', align: ' d-none' },
    { title: 'cellphones', key: 'cellphones', align: ' d-none' },


  ],
  isEditing: false,
  loading: false,
  localPath: null,
  openClientsForm: false,
  search: '',
  states: [
    'AL',
    'AK',
    'AS',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FM',
    'FL',
    'GA',
    'GU',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MH',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'MP',
    'OH',
    'OK',
    'OR',
    'PW',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VI',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
  ],
  valid: true
});

const form = ref(null);

const csvData = computed(()=>{
  return data.Clients.map((item) => ({
    ...item,
    name: item.name,
    phone: item.phone,
  }))
})

const csvExport = (arrData) => {
  // CSV File
  let csvContent = 'data:text/csv;charset=utf-8,'
  csvContent += [
    Object.keys(arrData[0]).join(';'),
    ...arrData.map((item) => Object.values(item).join(';')),
  ]
      .join('\n')
      .replace(/(^\[)|(\]$)/gm, '')

  const data = encodeURI(csvContent)
  const link = document.createElement('a')
  link.setAttribute('href', data)
  link.setAttribute('download', 'export.csv')
  link.click()
}

const listAll = () => {
  ApiWrapper.get('clients', 'list-clients')
  .then((response) => {
    data.Clients = response.clients;
    data.Clients.forEach(function (arrayItem) {
      arrayItem.phone = formatPhoneNumber(arrayItem.phone)
    });
    data.Clients.forEach(function (arrayItem) {
      if(arrayItem.streetaddress != null && arrayItem.city != null && arrayItem.state != null && arrayItem.zip != null) {
        arrayItem.clientAddress = arrayItem.streetaddress + ' ' + arrayItem.city + ', ' + arrayItem.state + ' ' + arrayItem.zip
      } else {
        arrayItem.clientAddress = ''
      }
    });

    data.loading = false
    data.dataLoading = false
  }).catch((err) => {
    ToastUtil.error(err);
    data.loading = false;
    data.dataLoading = false;
  })
}

const editItem = (item) => {
  data.isEditing = true;
  data.editedItem = JSON.parse(JSON.stringify(item));
  data.openClientsForm = true;
}

const acceptNumber = () => {
  let x = data.editedItem.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  data.editedItem.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
}

const formatPhoneNumber = (phoneNumberString) => {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  }
  return null
}

const deleteItem = (item) => {
  let deleteMessage = confirm(
      'Are you sure you want to delete this item?'
  )
  if (deleteMessage === true) {
    data.loading = true
    ApiWrapper.post('clients', 'delete-client', { item: item })
        .then((response) => {
          listAll()
          data.loading = false
          ToastUtil.successMsg('Deleted client');
        })
        .catch((err) => {
          ToastUtil.error(err);
          data.loading = false;
        })
  }
}

const close = () => {
  data.openClientsForm = false
  nextTick(() => {
    data.editedItem = Object.assign({}, data.defaultItem)
    data.isEditing = false
  })
}

const save = () => {
  if (form.value.validate()) {
    data.loading = true
    if (data.isEditing) {
      ApiWrapper.post('clients', 'edit-client', {
            editedItem: data.editedItem,
          })
          .then((response) => {
            listAll()
            activeComponentStore.notifyComponents(['clients'],compName);
            ToastUtil.successMsg('Updated client');
          })
          .catch((err) => {
            ToastUtil.error(err);
            data.loading = false;
          })
    } else {
      ApiWrapper.post('clients', 'create-client', {
            editedItem: data.editedItem,
          })
          .then((response) => {
            listAll()
            activeComponentStore.notifyComponents(['clients'],compName);
            ToastUtil.successMsg('Created client');
          })
          .catch((err) => {
            ToastUtil.error(err);
            data.loading = false;
          })
    }
    close()
  }
}

const cancel = () => {
  form.value.reset();
  data.openClientsForm = false
}

onMounted(() => {
  listAll()
})

</script>

<template>
  <v-container fluid style="min-height: 100vh;">
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Clients</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        >
        </v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-icon @click="csvExport(csvData)" v-if="data.Clients.length"> mdi-file-download </v-icon>

        <v-spacer></v-spacer>

        <v-btn
            v-if="!data.openClientsForm && Permissions.checkPermissions(['clients.create'])"
            size="small"
            variant="elevated"
            color="primary"
            @click="data.openClientsForm = true"
        >
          New Client
        </v-btn>
      </v-toolbar>

      <!-- New Clients Button -->
      <div v-if="data.openClientsForm">
        <v-card flat>
          <v-list>
            <v-list-item
                v-if="!data.isEditing"
                :title="'New Client'"
            />
            <v-list-item
                v-else
                class="primary--text"
                :title="'Edit Client'"
            />
          </v-list>

          <v-form ref="form" v-model="data.valid" lazy-validation class="mb-15">
            <v-text-field
                class="mx-4"
                v-model="data.editedItem.name"
                label="Name"
                :rules="[v => !!v || 'Name is required']"
            ></v-text-field>
            <v-text-field
                class="mx-4"
                v-model="data.editedItem.phone"
                label="Phone #"
                :rules="[FormValidation.phoneRules]"
                @input="acceptNumber()"
            ></v-text-field>
            <v-text-field
                class="mx-4"
                v-model="data.editedItem.streetaddress"
                label="Street Address"
                :rules="[v => !!v || 'Street Address is required']"
            ></v-text-field>
            <v-text-field
                class="mx-4"
                v-model="data.editedItem.city"
                label="City"
                :rules="[v => !!v || 'City']"
            ></v-text-field>
            <v-autocomplete
                class="mx-4"
                v-model="data.editedItem.state"
                :items="data.states"
                label="State"
                :rules="[v => !!v || 'State']"
            ></v-autocomplete>
            <v-text-field
                class="mx-4"
                v-model="data.editedItem.zip"
                label="Zip"
                :rules="[v => !!v || 'Zip']"
            ></v-text-field>
            <v-btn size="small" variant="elevated" class="ml-4 mr-2" color="primary" @click="save" :disabled="!data.valid">Save</v-btn>
            <v-btn size="small" variant="elevated" color="error" @click="cancel">Cancel</v-btn>
          </v-form>
        </v-card>
      </div>

      <v-row>
        <v-col cols="6">
          <v-text-field
              class="ml-4"
              v-model="data.search"
              append-inner-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
          ></v-text-field>
        </v-col>
      </v-row>

      <v-data-table
          :headers="data.headers"
          :items="data.Clients"
          :search="data.search"
          class="elevation-1"
          :loading="data.dataLoading"
          loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.name`]="{ item }">
          <RouterLink :to="`/client/${item.id}`">
            {{ item.name }}
          </RouterLink>
        </template>
        <template v-slot:[`item.clientAddress`]="{ item }" >
          {{ item.clientAddress }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-row>
            <v-col cols="6">
              <v-icon v-if="Permissions.checkPermissions(['clients.update'])" class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
            </v-col>
            <v-col cols="6">
              <v-icon v-if="Permissions.checkPermissions(['clients.delete'])" @click="deleteItem(item)"> mdi-delete </v-icon>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
  [v-cloak] {
    display: none;
  }
</style>